module.exports = __webpack_public_path__ + "media/images/bg/shapes/circle-08790b0d089496079f3dc8c61e3c3c50.svg";